import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useError } from '../../hooks/useError';
import { subscribeToGlobalErrors, type GlobalErrorPayload } from '../../utils/globalErrorHandler';

const GlobalErrorListener: React.FC = () => {
  const navigate = useNavigate();
  const { setError } = useError();

  useEffect(() => {
    const handleGlobalError = (payload: GlobalErrorPayload) => {
      setError({
        errorType: payload.errorType,
        retryAction: payload.retryAction,
        retryUrl: payload.retryUrl ?? payload.previousUrl,
        previousUrl: payload.previousUrl,
        statusCode: payload.statusCode,
        message: payload.message,
        requestConfig: payload.requestConfig,
      });

      const navigationState = {
        retryUrl: payload.retryUrl ?? payload.previousUrl,
        previousUrl: payload.previousUrl,
        errorType: payload.errorType,
        statusCode: payload.statusCode,
        message: payload.message,
      };

      const target = '/error';
      const isAlreadyOnErrorPage = window.location.pathname === target;

      navigate(target, {
        replace: isAlreadyOnErrorPage,
        state: navigationState,
      });
    };

    const unsubscribe = subscribeToGlobalErrors(handleGlobalError);
    return () => {
      unsubscribe();
    };
  }, [navigate, setError]);

  return null;
};

export default GlobalErrorListener;
